import { createDetailReducer } from '../../../common/services/reducerCreator';

export default createDetailReducer({
    modelName: 'MAIN_BOOKMAKER_MAPPING'
});
